
import { RevTag } from '@backmarket/design-system'

import RatingInfo from '@internal-reviews/components/RatingInfo'

import EcoBlockAnchor from '../EcoBlockAnchor'
import Gallery from '../Gallery'
import Model from '../Model'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './FixedContainer.constants'
import translations from './FixedContainer.translations'

export default {
  components: {
    EcoBlockAnchor,
    Gallery,
    Model,
    RatingInfo,
    RevTag,
  },

  props: {
    reassurance: {
      type: Object,
      required: true,
    },

    ratings: {
      type: Object,
      required: true,
    },

    images: {
      type: Array,
      required: true,
    },

    page: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    modelTitle: {
      type: String,
      required: true,
    },

    modelSubtitles: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    isOutOfStock() {
      return this.page.variations.isOutOfStock
    },

    categoryId() {
      return this.product.trackingDetails.category3MarketplaceCategory_ID
    },
  },
}
